import {logger, pomFeatureTranslations} from '@features/pom'
import {
  combineTranslationBundles,
  Localization,
  loadPackageTranslations,
  setupTranslationLanguageSync,
  type LanguageCode
} from '@hconnect/common/localization-loaders'
import {uikitTranslations} from '@hconnect/uikit'
import i18n from 'i18next'

export const supportedLanguages: LanguageCode[] = ['de-DE', 'en-US']

const loader = async (filename: string): Promise<Record<string, unknown> | undefined> => {
  const log = logger.context('localization', 'loader')
  try {
    return await import(`./${filename}.json`)
  } catch (err: unknown) {
    log.tags({filename, message: (err as Error)?.message}).error('Could not load translation')
    throw err
  }
}

const externalPackageTranslations = combineTranslationBundles([
  uikitTranslations,
  pomFeatureTranslations
])

export async function initLocalization() {
  await Localization({
    fallbackLng: 'en-US',
    compatibilityJSON: undefined,
    supportedLngs: [...supportedLanguages],
    backend: {
      loader
    }
  })

  void loadPackageTranslations(i18n, externalPackageTranslations)
  setupTranslationLanguageSync(i18n, externalPackageTranslations)
}
